module.exports = __webpack_public_path__ + "static/Creator 14 - @MacieJay-42b72fd712712466f7fdd79b72b4219d.png";